export { default as ErrorBandaid } from "./error-bandaid.svg";
